import { render, staticRenderFns } from "./statusFeedback.vue?vue&type=template&id=36a66602&scoped=true&"
import script from "./statusFeedback.vue?vue&type=script&lang=js&"
export * from "./statusFeedback.vue?vue&type=script&lang=js&"
import style0 from "./statusFeedback.vue?vue&type=style&index=0&id=36a66602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a66602",
  null
  
)

export default component.exports